import React, {Component} from 'react';
let clone = require("fast-clone");
let fs = require("file-saver");
import XLSX from 'xlsx'

import image from "./components/pdfImage.js";
import {
  DropdownButton,
  MenuItem,
  Grid,
  Row,
  Col,
  Thumbnail,
  Button,
  Table,
  FormGroup,
  ControlLabel,
  FormControl
} from "react-bootstrap"
import isString from 'lodash.isstring'

// Inlude the localization from the global scope
let text = window.text

const idUtstickVal = "uv_";
const idUtstick = "utstick";

/// Round to 1st digital
let round_near = function(val){
  let out = Math.round(val*1e5)/1e5;
  if (out == 0 || !isFinite(out)){
    return ""
  }
  return out
}


/// converts from mm to m for applicable properties
/// Note: Slight hack utilizing that everything is in mm execpt entries with name 'angle'
/// Proper conversion could be implemented if time allows
let convertToMm = function(value, property){
  if (isString(property) && property.indexOf("angle") !== -1){
    return value;
  }
  return value*1000.0;
}

function createRab(t,rabatt, i) {
  return <FormControl
           style={{    width: "5em",
                       display: "initial",
                       height: "24px"}}
           type="text"
           onChange={(e)=> {
               let v = e.target.value.replace("%","")
               let r = clone(t.props.rabatt)
               for(;r.length <=i;) {
                 r.push(t.props.user.get("deduction")*100)
               }
               r[i] = v
               t.props.set({rabatt:r})
           }}
           value={Math.round(100-100*rabatt[i])} />
}

// Solution displays and illustrates a solution as an svg image
class Solution extends Component {
  // Get all values as a map for this roof
  getRoofValues(ins) {
    let ret = {}
    for(let i = 0; i < ins.length; i++){
      ret[ins[i].name] = this.props.vals["val_" + ins[i].name];
    }
    return ret;
  }
  // Different state id for utstikks: Get all values as a map for this utstikk
  getUtstikkValues(ins,j) {
    let ret = {}
    for(let i = 0; i < ins.length; i++){
      ret[ins[i].name] = this.props.vals[idUtstick][idUtstickVal+j+"_"+i + ins[i].name];
    }
    return ret;
  }

  render(){
    let rabatt = this.props.rabatt
    rabatt = rabatt.map(rabatt => {
      if(!(rabatt >= 0 && rabatt < 100)) {
        if(rabatt >= 100)
          rabatt = 0.0
        else
          rabatt = 1.0
      } else {
        rabatt = (100-rabatt)/100
      }
      return rabatt})
    // As a ugly way - asume never more than 200 items and add the default to them
    for(let i = rabatt.length; i < 200; i++) {
      if(this.props.user == undefined)
        rabatt.push(1)
      else
        rabatt.push(1-this.props.user.get("deduction")*1)
    }


    // Build the output, including a result table
    let table = {
      plates : [],
      pipes : [],
      fittings: [],
      extras: [],
    }
    let psum = 0
    this.props.sol.required.map((it, i) => {
      // Get the nob of the corresponding one
      let nobb = this.props.plate.nobb
      if(this.props.plate.height.type == "stepwise") {
        let ind = this.props.plate.height.height.indexOf(it.height/1000)
        if(ind == -1)
          ind = this.props.plate.height.height.indexOf(it.height/1000 + "")
        nobb = this.props.plate.nobb[this.props.plate.height.height.indexOf(it.height/1000)]
      }
      nobb = nobb == undefined ? "?" : nobb
      let p = this.props.price[nobb] == undefined ? "?" : this.props.price[nobb](it.height)
      psum += p*it.no*rabatt[i]

      table.plates.push([
        "ABCDEFGHIJKLMNOPQRSTUVWXYZ______________________________"[i]+")",
        nobb,
        this.props.plate.name + " (" + it.height+"mm)",
        it.no,
        this.props.user == undefined ? "" : (isFinite(p) ? Math.round(p) + ",-": "?"),
        this.props.user == undefined ? "" : i,
        this.props.user == undefined ? "" : (isFinite(p) ? Math.round(p*it.no*rabatt[i]) + ",-": "?")
      ])
    })
    /* Insert productOptions */
    const {productOptions} = this.props
    if (productOptions) {
      productOptions.forEach(({name, nobb, id, type, items, pipeLength, category}, i) => {
        const priceParams = type === 'pipe' ? [0, pipeLength * 1000] : []
        const p = this.props.price[nobb] ? this.props.price[nobb](...priceParams) : 0
        psum += items * p * rabatt[i + this.props.sol.required.length]
        const pString = isFinite(p) ? `${Math.round(p)},-` : '?'
        const sumString = isFinite(p * items) ? `${Math.round(items * p *rabatt[i + this.props.sol.required.length])},-` : '?'

        let tbl = [
          "",
          nobb,
          name,
          items,
          this.props.user ? pString : '',
          this.props.user ? i + this.props.sol.required.length : '',
          this.props.user ? sumString : '',
        ]
        if(category=="takrenner") {
          table.pipes.push(tbl)
        } else if(category=="beslag") {
          table.fittings.push(tbl)
        } else {
          table.extras.push(tbl)
        }
      })
    }

    // Create the drawings
    let {roofViews, dwgs} = this.buildRoofViews()

    // And display it all, by building from the created table
    return (
      <div>
        <span>
          {this.resultTable(text.c_plates, table.plates, rabatt)}
          {this.resultTable(text.c_pipes, table.pipes, rabatt)}
          {this.resultTable(text.c_fittings, table.fittings, rabatt)}
          {this.resultTable(text.c_extras, table.extras, rabatt)}

          {this.props.user == undefined ? null : <p className="totalpris"><b>{text.totalprice + ": " + psum.toFixed(2) + ",-"}</b></p> }
          {this.props.user == undefined ? null : <p className="frakt">{text.transport}</p> }

          <div style={{textAlign:"right"}}>
            <Button
              bsStyle='primary'
              style={{marginRight: "1em"}}
              className="print"
              onClick={ ()=> {
                const headerExtra = this.props.user ? [text.price, `${text.rabatt} (%)`, text.total] : []
                const allTables = [...table.plates, ...table.pipes, ...table.fittings, ...table.extras]
                const sheetData = [
                  [
                    text.nobb,
                    text.prodn,
                    text.numb,
                    ...headerExtra
                  ],
                  ...allTables.map((l, i) => {
                    const rab = Math.round(100-100*rabatt[i])
                    const base = [
                      `${l[1]}`,
                      l[2],
                      l[3]
                    ]
                    if (this.props.user) {
                      return [
                        ...base,
                        parseInt(l[4]),
                        rab,
                        parseInt(l[6])
                      ]
                    }
                    return base
                  })
                ]
                const ws = XLSX.utils.aoa_to_sheet(sheetData);
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, "Tata");
                XLSX.writeFile(wb, "Tata.xlsx")
              }}
            >
              {text.downloadSheet}
            </Button>
            <Button bsStyle='primary' style={{marginRight: "1em"}} className="print"
              onClick={()=>createpdf(this.props.user, table, dwgs, rabatt)}>{text.pdf}</Button>
            <Button bsStyle='primary' className="print"
              onClick={()=>window.print()}>{text.print}</Button>
          </div>
          <br/>

        </span>
        <span>
          {roofViews}
        </span>
      </div>)
  }

  // Build the stuff that will be used for the drawings
  buildRoofViews() {
    // Define where we store the drawings that should be appended to the pdf
    let dwgs = [];
    // Calculate bounds for each roof in the layout
    let bounds = [];
    let maxDiffX = 0; // To be able to normalize/center all
    for(let k = 0; k < this.props.sol.roofs.length; k++){
      let roof = this.props.sol.roofs[k];
      let patches = roof.topatches();
      let transforms = roof.patchtransforms();
      let minX = 1e6,
          minY = 1e6,
          maxX = -1e6,
          maxY = -1e6;
      for(let i = 0; i < patches.length; i++) {
        let patch = patches[i];
        for(let j = 0; j < patch.length; j++) {
          let trans = transforms[i]
          let p = patch[j];
          let tx = p.X, ty = p.Y
          // translate and rotate the position such that we get the final
          // position it will have
          p.X += trans.t[0]
          p.Y += trans.t[1]
          // And then do the rotation
          p.tX = p.X - trans.r[1]
          p.tY = p.Y - trans.r[2]
          let a = trans.r[0]/180*Math.PI
          p.X = Math.cos(a)*p.tX - Math.sin(a)*p.tY
          p.Y = Math.sin(a)*p.tX - Math.cos(a)*p.tY
          p.X += trans.r[1]
          p.Y += trans.r[2]
          if(p.X < minX)
            minX = p.X
          if(p.Y < minY)
            minY = p.Y
          if(p.X > maxX)
            maxX = p.X
          if(p.Y > maxY)
            maxY = p.Y
          p.X = tx
          p.Y = ty
        }
        let diffX = maxX-minX;
        if (diffX > maxDiffX){
          maxDiffX = diffX;
        }
      }
      bounds.push({minX:minX,minY:minY,maxX:maxX,maxY:maxY});
    }

    // Calculate translations in x and y for each roof
    for (let i = 0; i < bounds.length; i++){
      // Make each roof centered
      let centeredTX = (maxDiffX - (bounds[i].maxX-bounds[i].minX))/2.0;
      bounds[i].tX = -bounds[i].minX + centeredTX;

      // Let it have proper y offset
      if (i === 0){
        bounds[i].oY = -bounds[i].minY;
      } else{
        let diffPrev = bounds[i-1].maxY - bounds[i-1].minY
        bounds[i].oY = diffPrev + bounds[i-1].oY;
      }


      bounds[i].tX = -bounds[i].minX
      bounds[i].oY = -bounds[i].minY
    }

    let images = [];
    let paddingY = 250; // Padding above and below
    let cumPaddingY = 0;
    for(let k = 0; k < this.props.sol.roofs.length; k++){
      let bound = bounds[k];
      let height = bound.maxY - bound.minY + 2*paddingY*0;
      let startX = 0;
      let startY = 0 ; // bound.minY+bound.oY + cumPaddingY;
      let diffY =  bound.maxY -  bound.minY
      let diffX = bound.maxX -  bound.minX

      // We need to make sure that we can fit the font in addition to the
      // polygons, so we scale the area correspondingly:
      let mmin = 550
      let mx = Math.max(0.03*diffX, mmin)
      let my = Math.max(0.04*diffY, mmin)

      images.push(
        <Patch
          key={k}
          sol={this.props.sol}
          current={k}
          width={"100%"}
          ox={10}
          oy={10}
          height={height}
          sx={0}
          sy={0}
          offset={{X:bound.tX, Y:bound.oY}}
          viewBox={(-mx) + " " +(-my) + " " + (diffX + 2*mx) + " " + (diffY + 2*my)}
        />
      )
      cumPaddingY += 2*paddingY;
      dwgs.push({text: text.your + this.props.sol.roofs[k].name, style: "subheader", pageBreak:"before"});

      dwgs.push(createcanvas(
        k,
        this.props.sol,
        k,
        "100%",
        10,
        10,
        height,
        0,
        0,
        {X:bound.tX, Y:bound.oY + cumPaddingY + paddingY},
        (startX-0.025*maxDiffX) + " " +(startY) + " " + (maxDiffX*1.05) + " " + (height),
        bound))
    }

    // Build the list of properties which define the roof:
    let inputs = [];
    let insArr = this.props.ins
    for (let j = 0; j < insArr.length; j++){
      let ins = insArr[j];
      inputs.push([]);
      for(let i = 0; i < ins.length; i++) {
        let vv;
        let title = ins[i].title
        if (j===0) {
          vv = this.props.vals["val_" + ins[i].name];
          if (ins[i].alternatives !== undefined){
            let name = this.props.vals["btn_"+ins[i].name]
            let values = this.getRoofValues(ins)
            title = text[name]
            vv = round_near(ins[i].alternatives.convertTo(name, vv, values));
            vv = convertToMm(vv,this.props.vals["btn_"+ins[i].name])
          }else{
            vv = vv * 1000;
          }
        } else {
          // Different id parameter for utsticks
          // -1 account for that the original roof has different labeling, todo:fix
          vv = this.props.vals[idUtstick][idUtstickVal +(j-1)+"_"+i+ ins[i].name];
          if (ins[i].alternatives !== undefined){
            let name = this.props.vals["btn_"+(j-1)+"_"+ins[i].name]
            let values = this.getUtstikkValues(ins,j-1)
            title = text[name]
            vv = round_near(ins[i].alternatives.convertTo(name, vv, values));
            vv = convertToMm(vv,this.props.vals["btn_"+(j-1)+"_"+ins[i].name])
          }else{
            vv = vv * 1000;
          }
        }
        inputs[j].push(
          <p key={i} >
            <b>{title + ": "}</b>
            {vv == undefined ? "" : vv}
          </p>
        )
      }
    }

    let roofViews = [];
    for(let i = 0; i < this.props.sol.roofs.length; i++){
      let roofName = this.props.sol.roofs[i].name;
      let roofType = this.props.sol.types[i];
      let category = this.props.sol.categories[i];
      let roofSrc = category+"/"+roofType+".png"
      roofViews.push(
        <div key={i} >
          <h1 className="split">{text.your + this.props.sol.roofs[i].name}</h1>
          <div style={{padding: "1.5em"}}>
            <Row>
              <Col sm={12} md={4}>
                <img className="result" style={{width: "100%", marginBottom: "1em"}} src={roofSrc} />
                {inputs[i]}
              </Col>
              <Col sm={12} md={8}>
                <div style={{padding: "1.5em", paddingTop: "0"}}>{images[i]}</div>
              </Col>
            </Row>
          </div>
        </div>
      )
    }

    return {roofViews, dwgs}
  }

  resultTable(title, data, rabatt) {
    if(data == undefined || data.length == undefined || data.length < 1)
      return null
    return (<span>
      <h1 className="split">{title}</h1>
      <div style={{overflowX:"auto"}}>
        <Table className="print" striped bordered condensed hover>
          <thead>
            <tr>
              <th>{text.nobb}</th>
              <th>{text.prodn}</th>
              <th className="aright">{text.numb}</th>
              {this.props.user == undefined ? null : <th className="aright">{text.price}</th>}
              {this.props.user == undefined ? null : <th className="aright">{text.rabatt + " (%)"}</th>}
              {this.props.user == undefined ? null : <th className="aright">{text.total}</th>}
            </tr>
          </thead>
          <tbody>
            {data.map((el,i) => {
               return (
                 <tr key={i}>
                   <td>{el[1]}</td>
                   <td>{el[2]}</td>
                   <td className="aright">{el[3]}</td>
                   {this.props.user == undefined ? null : <td className="aright">{el[4]}</td>}
                   {this.props.user == undefined ? null : <td className="aright">{
                     createRab(this,rabatt, el[5])
                   }</td>}
                   {this.props.user == undefined ? null :  <td className="aright">{el[6]}</td>}
                 </tr>)
            })
            }
          </tbody>
        </Table></div></span>
    )
  }
}



// A Patch shows a svg image with the content
class Patch extends Component {
  constructor(props, context) {
    super(props, context)
  }

  render() {
    let ox = this.props.ox,
        oy = this.props.oy,
        sx = this.props.sx,
        sy = this.props.sy,
        offset = this.props.offset,
        width = this.props.width,
        current = this.props.current;

    let cx = (x) => x,
        cy = (y) => y;

    let path = (arr, o, ii, pa, cn) => {
      let d = "M " + cx(arr[0].X+o.X) + " " + cy(arr[0].Y+o.Y);
      for(let i = 1; i < arr.length; i++) {
        d += " L " + cx(arr[i].X+o.X) + " " + cy(arr[i].Y+o.Y)
      }
      d += "Z"
      return <path className={cn} style={{strokeWidth: (this.props.height/300+"px")}} key={ii} d={d} id={"pa_" + pa} stroke="black" />
    }

    let roofs = this.props.sol.roofs;
    // Find cumulative starting patch number of roof
    let cum = 0;
    for (let i = 0; i < roofs.length; i++){
      if (current === i)
        break;
      cum += roofs[i].topatches().length;
    }

    // Draw out all tiles for this roof
    let roof = roofs[current];
    let patches = roof.topatches();
    let objs = [];

    for(let i = 0; i < this.props.sol.pieces.length; i++) {
      let piece = this.props.sol.pieces[i];
      // Reject pieces not on this roof
      if (piece.patch < cum || piece.patch >= cum+patches.length)
        continue;

      for (let j = 0; j < patches.length; j++){
        // Add piece if in the range of our roof
        if (piece.patch === cum+j){
          if(objs[j] === undefined)
            objs[j] = [];
          objs[j].push(path(piece.outline, piece.patchPosition, i+"-"+j, piece.plate))
          // Calculate the center point of the piece so we can put the letter there
          let x = 0, y = 0;
          let my = 1100000;
          let minX = 1e11, maxX = -1e11
          let tm = 1e11, tM = -1e11
          piece.outline.map(p => {
            x += cx(p.X+piece.patchPosition.X) / piece.outline.length
            y += cy(p.Y+piece.patchPosition.Y) / piece.outline.length
            if(my > cy(p.Y+piece.patchPosition.Y))
              my = cy(p.Y+piece.patchPosition.Y)
            if(p.X > maxX)
              maxX = p.X
            if(p.X < minX)
              minX = p.X

            if(cx(p.X+piece.patchPosition.X) > tM)
              tM = cx(p.X+piece.patchPosition.X)
            if(cx(p.X+piece.patchPosition.X) < tm)
              tm = cx(p.X+piece.patchPosition.X)
          })
          x = 0.5*tm + 0.5*tM
          let dx = maxX -minX
          // Add the text
          // Fontsize calculation might require some fine tuning
          let fs = this.props.height/450*12
          fs = 1000/4.0*1.33
          // Limit size of fs for smaller plates
          let plateWidth = dx
          fs = Math.min(fs,plateWidth/2.5)
          // Shift every other text
          let txtoffset = 0
          if(i%2 == 0){
            txtoffset = fs*0.4
          }else{
            txtoffset = -fs*0.2
          }

          let cheight  = this.props.sol.required[piece.row].height

          // get the local rotation of this one
          let trans = this.props.sol.transforms[cum+j]
          let rotate = ""
          if(trans != undefined && (Math.abs(trans.r[0]- 180) < 1) || (Math.abs(trans.r[0]- -90) < 1)) {
            rotate = "rotate(180,"+x+","+(-fs/3)+")"
          }
          objs[j].push(<g key={`${i}${j}`} transform={"translate(0, " + (my-fs-txtoffset) + ") scale(1,-1)"}>
            <text textAnchor="middle" fontSize={fs} transform={rotate} x={x}>{""+cheight}</text></g>)
        }
      }
    }

    if(objs.length == 0)
      return (
        <svg className="drawing" width={width} viewBox={this.props.viewBox}> </svg>
      )

    // Apply transformations to the content
    let cont = [];
    for(let i = 0; i < objs.length; i++) {
      let patch = patches[i];
      // Push the outline of each patch so we can show them thicker
      objs[i].push(path(patch,{X:0,Y:0},"asd","","outline"))
      let trans = this.props.sol.transforms[cum+i]; // TODO: Can a patch be not added to objs?
      cont.push(
        <g key={cum+i} transform={"translate("+ (offset.X) +", "+(-offset.Y)+")"}>
          <g transform={"rotate("+ trans.r[0] +", "+ trans.r[1]+","+trans.r[2]+")"}>
            <g transform={"translate("+ (trans.t[0]) +", "+ (trans.t[1]  )+")"}>
              {objs[i]}
            </g>
          </g>
        </g>
      )
    }

    return (
      <svg className="drawing" width={width} viewBox={this.props.viewBox}>
        <g transform={"scale(1,-1)"}>
          {cont}
        </g>
      </svg>
    )
  }
}

function createcanvas( key, sol, current, width, ox, oy, height, sx, sy, offset, viewBox, bound) {
  let r = {canvas: [],
			     absolutePosition: {x: 100, y: 300},
           tt:[]}

  let tr = (trans,p, x, y) => {
    p[x] += trans.t[0]
    p[y] += trans.t[1]
    p.tX = p[x] - trans.r[1]
    p.tY = p[y] - trans.r[2]
    let a = trans.r[0]/180*Math.PI
    p[x] = Math.cos(a)*p.tX - Math.sin(a)*p.tY
    p[y] = Math.sin(a)*p.tX - Math.cos(a)*p.tY
    p[x] += trans.r[1]
    p[y] += trans.r[2]
    return p
  }


  let path = (arr, o, ii, pa, cn, trans) => {
    let ls = []
    for(let i = 1; i < arr.length; i++) {
      ls.push(
				tr(trans,tr(trans,{
					type: 'line',
					x1: (arr[i-1].X+o.X), y1:(arr[i-1].Y+o.Y),
					x2: (arr[i].X+o.X), y2:(arr[i].Y+o.Y),
					lineWidth: 1
				},"x1","y1"),"x2","y2"))
    }
    ls.push(
			tr(trans,tr(trans,{
				type: 'line',
				x1: (arr[0].X+o.X), y1:(arr[0].Y+o.Y),
				x2: (arr[arr.length-1].X+o.X), y2:(arr[arr.length-1].Y+o.Y),
				lineWidth: 1
			},"x1","y1"),"x2","y2"))

    return ls
  }

  let roofs = sol.roofs;
  // Find cumulative starting patch number of roof
  let cum = 0;
  for (let i = 0; i < roofs.length; i++){
    if (current === i)
      break;
    cum += roofs[i].topatches().length;
  }
  let s = 440/(bound.maxX - bound.minX)
  // we might have to scale for vertical also
  let sv = 500/(bound.maxY-bound.minY)
  if(sv < s) {
    s = sv
  }


  // Draw out all tiles for this roof
  let roof = roofs[current];
  let patches = roof.topatches();
  let objs =[]
  for(let i = 0; i < sol.pieces.length; i++) {
    let piece = sol.pieces[i];
    // Reject pieces not on this roof
    if (piece.patch < cum || piece.patch >= cum+patches.length)
      continue;

    for (let j = 0; j < patches.length; j++){
      // Add piece if in the range of our roof
      if (piece.patch === cum+j){
        let trans = sol.transforms[cum+j]
        if(objs[j] === undefined)
          objs[j] = [];
        objs[j] = objs[j].concat(path(piece.outline, piece.patchPosition, i, piece.plate, "",trans))
        // Calculate the center point of the piece so we can put the letter there
        let x = 0, y = 0;
        let my = 111000;
        let cheight  = sol.required[piece.row].height
        piece.outline.map(p => {
          let pp = clone(p)
          pp.X += piece.patchPosition.X
          pp.Y += piece.patchPosition.Y
          pp = tr(trans, pp,"X","Y")
          x += pp.X / piece.outline.length
          y += pp.Y / piece.outline.length
          if(my > pp.Y)
            my = pp.Y
        })

        let writeRotatedText = function(text) {
          let c = document.createElement('canvas');
          let ctx = c.getContext('2d');

          //Set font size before measuring
          let font = 50;
          ctx.font = font + 'px Arial, sans-serif';
          //Get width of text
          let metrics = ctx.measureText(text);
          //Set canvas dimensions
          c.width = font+20; //The height of the text. The text will be sideways.
          c.height = metrics.width; //The measured width of the text
          //After a canvas resize, the context is reset. Set the font size again
          ctx.font = font + 'px Arial';
          //Set the drawing coordinates
          let x = font/2;
          let y = metrics.width/2;
          //Style
          ctx.fillStyle = '#1199f0';
          ctx.textAlign = 'center';
          ctx.textBaseline = "bottom";
          //Rotate the canvas and draw the text
          ctx.save();
          ctx.translate(x, y);
          ctx.rotate(-Math.PI / 2);
          ctx.fillText(text, 0, font);
          ctx.restore();

          return c.toDataURL();
        };

        r.tt.push({image: writeRotatedText(cheight), fit: [10, 100],
			             absolutePosition: { x: s * (x-bound.minX) + 92.5, y: s * (y-bound.minY) + 290 }
        })
      }
    }
  }
  // Calculate the scaling we will need based on that the full width
  // of the canvas will be 515 units

  objs.map((it,ii) => it.map(o => {

    o.x1 -= bound.minX
    o.x2 -= bound.minX
    o.y1 -= bound.minY
    o.y2 -= bound.minY
    o.x1 *= s
    o.x2 *= s
    o.y1 *= s
    o.y2 *= s
    r.canvas.push(o)
  }))
  return r
}

function makeTable(t, rabatt, user){

  t = t.map(e => {
    e[5] = "" + Math.round(100-100*rabatt[e[5]]) + "%"
    return e
  })

  t.unshift(["", {bold:true, text:text.nobb, color: "white"}, {bold:true, text:text.prodn, color: "white"},{bold:true, text:text.numb, color: "white"}, {bold:true, text:text.price, color: "white"}, {bold:true, text:text.rabatt + " (%)", color: "white"}, {bold:true, text:text.total, color: "white"}])
  let widths = [20, 'auto', '*', 40, 40, 40, 40]
  if(user != undefined)
    user.get("img")+""
  else {
    for(let i = 0; i < t.length; i++) {
      t[i] = t[i].slice(0,4)
    }
    widths = widths.slice(0,4)
  }
  return {
		style: 'table',
		headerRows: 1,
		table: {
			widths: widths,
			body:t
		},
		layout: {
      fillColor: function (i, node) { return i == 0 ? "#1199f0" : ((i % 2 === 0) ?  '#F1F9FE' : null)},
      defaultBorder: false,
      border: 'headerLineOnly'
    }
	};


}

function createpdf(user, t, dwgs, rabatt) {

  var docDefinition =
    {
      content: [
        {
	        image: image,
	        width: 40,
			    absolutePosition: {x: 530, y: 15}
		    }
      ],
      styles: {
        header: {
          fontSize: 18,
          bold: true,
          margin: [0, 0, 0, 10]
        },
        subheader: {
          fontSize: 16,
          bold: true,
          margin: [0, 10, 0, 5]
        },
        table: {
          margin: [0, 5, 0, 15]
        },
        tableHeader: {
          bold: true,
          fontSize: 13,
          color: 'black'
        },
        canvasText: {
          fontSize: 8,
          color: 'blue',
          pageOrientation: 'portrait'
        }
      },
    };

  if (t.plates.length) docDefinition.content = docDefinition.content.concat([{text: text.c_plates, style: 'subheader'},
                                                                             makeTable(t.plates, rabatt, user)]);
  if (t.pipes.length) docDefinition.content = docDefinition.content.concat([{text: text.c_pipes, style: 'subheader'},
                                                                            makeTable(t.pipes, rabatt, user)]);
  if (t.fittings.length) docDefinition.content = docDefinition.content.concat([{text: text.c_fittings, style: 'subheader'},
                                                                               makeTable(t.fittings, rabatt, user)]);
  if (t.extras.length) docDefinition.content = docDefinition.content.concat([{text: text.c_extras, style: 'subheader'},
                                                                             makeTable(t.extras, rabatt, user)]);
  dwgs.map(d => {
    docDefinition.content.push(d);
    if(d.tt != undefined){
      docDefinition.content = docDefinition.content.concat(d.tt);
    }
  })
  pdfMake.createPdf(docDefinition).download('tata.pdf');
}

export default Solution;



// WEBPACK FOOTER //
// ./Solution.js